// extracted by mini-css-extract-plugin
export default {"header":"PageHub_header__g3SXS","image":"PageHub_image__SV2x3"};